import * as ColorChecker from "./components/projectCard.js";
const profileCards = document.querySelectorAll(".service-left, .slider .slide, .headline, .insights-headline");

if (profileCards) {
  profileCards.forEach(function (el) {
    const keyColor = getComputedStyle(el).getPropertyValue("--keyColor");
    if (keyColor) {
      const contrast = ColorChecker.checkContrast(keyColor, el);
      const element = el;

      if (!contrast) {
        element.style.setProperty("color", "#fff");
      }
    }
  });
}

// Set aria-current on current page
const url = window.location.pathname.replace(/\/$/, "");
const lastSegment = url.substring(url.lastIndexOf("/") + 1);
const profileLinks = document.querySelectorAll(".switcher-label");
profileLinks.forEach((link) => {
  if (link.getAttribute("href") === "/profile/" + lastSegment + "/") {
    link.setAttribute("aria-current", "page");
  }
});

// Make focused Profile section labels clickable
document.querySelectorAll(".switcher-tab label").forEach((label) => {
  label.addEventListener("focus", (e) => {
    label.addEventListener("keydown", (keydown) => {
      if (keydown.key === "Enter" || keydown.key === "Space") {
        keydown.preventDefault();
        label.click();
        label.focus();
      }
    });
  });
});
